import isChromatic from "./isChromatic";

export const isStorybook = () => {
  if (process.env.STORYBOOK_ENV === "true" || isChromatic()) {
    return true;
  }
  return false;
};
